module.exports = __webpack_public_path__ + "media/Imagefilm.078b5730.mp3";